import React from 'react';
import {Link, NavLink, Route, Routes} from "react-router-dom";
import Subscriptions from "../Subscribe/Subscriptions";
import GameChats from "../Chat/GameChats";
import {Col, Container, Row} from "react-bootstrap";

export default class Customer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            isLoadedGeneralInfo: false,
            subscriptions: [],
            isSubscriptionsLoaded: false,
            generalInfo: []
        };
    }

    componentDidMount() {
        if(this.props.userId) {
            fetch(process.env.REACT_APP_API_URL + "/customer/" + this.props.userId,{
                headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
            })
                .then(res => res.json())
                .then(
                    (result) => {
                        this.setState({
                            isLoadedGeneralInfo: true,
                            generalInfo: result.data
                        });
                    },

                    (error) => {
                        this.setState({
                            isLoadedGeneralInfo: true,
                            error
                        });
                    }
                )
        }
    }

    render() {
        let generalInfoFormatted = [];
        let subscriptionsFormatted = [];


        if (!this.props.userId) {
            subscriptionsFormatted = <div>Loading...</div>;
        } else {
            subscriptionsFormatted = (
                <div>
                    <hr/>
                    <button id='subscriptions-button' onClick={(e) => {
                        let block = document.getElementById('subscriptions');

                        if (block.style.display === 'none') {
                            block.style.display = 'block';
                        } else {
                            block.style.display = 'none';
                        }
                    }}>Subscriptions</button>
                    <div style={{display: 'none'}} id='subscriptions'>
                        <Subscriptions loadGames={false} userId={this.props.userId}/>
                    </div>
                    <hr/>
                </div>
            );
        }

        const { errorGeneralInfo, isLoadedGeneralInfo, generalInfo } = this.state;
        if (errorGeneralInfo) {
            generalInfoFormatted = <div>Error: {errorGeneralInfo.message}</div>;
        } else if (!isLoadedGeneralInfo) {
            generalInfoFormatted = <div>Loading...</div>;
        } else {
            generalInfoFormatted = (
                <section style={{backgroundColor: "#eee"}}>
                    <div className="container py-5">
                        <div className="row">
                            <div className="col">
                                <nav aria-label="breadcrumb" className="bg-light rounded-3 p-3 mb-4">
                                    <ol className="breadcrumb mb-0">
                                        <li className="breadcrumb-item active" aria-current="page">User Profile</li>
                                    </ol>
                                </nav>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-lg-4">
                                <div className="card mb-4">
                                    <div className="card-body text-center">
                                        <img src={generalInfo.icon ? generalInfo.icon : "https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-chat/ava3.webp"}
                                             alt="avatar"
                                             className="rounded-circle img-fluid" style={{width: '150px;'}}/>
                                        <h5 className="my-3">{generalInfo.first_name} {generalInfo.last_name}</h5>
                                        <p className="text-muted mb-1">{generalInfo.role}</p>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm">
                                        <center><h5>Subscriptions</h5></center>
                                        <Subscriptions loadGames={false} userId={generalInfo.id}/>
                                    </div>
                                </div>

                            </div>
                            <div className="col-lg-8">
                                <div className="card mb-4">
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-sm-3">
                                                <p className="mb-0">Full Name</p>
                                            </div>
                                            <div className="col-sm-9">
                                                <p className="text-muted mb-0">{generalInfo.first_name} {generalInfo.last_name}</p>
                                            </div>
                                        </div>
                                        <hr/>
                                        <div className="row">
                                            <div className="col-sm-3">
                                                <p className="mb-0">Email</p>
                                            </div>
                                            <div className="col-sm-9">
                                                <p className="text-muted mb-0">{generalInfo.email}</p>
                                            </div>
                                        </div>
                                        <hr/>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="card mb-4 mb-md-0">
                                            <div className="card-body">
                                                {generalInfo.companies.length > 0 ?
                                                    <div class="table-responsive" style={{
                                                        overflowX: "auto",
                                                        width: "100%",
                                                        whiteSpace: "nowrap"
                                                    }}>
                                                        <table class="table table-striped table-hover">
                                                            <caption>List of companies</caption>
                                                            <thead class="thead-light">
                                                            <tr>
                                                                <th scope="col">Name</th>
                                                                <th scope="col">Games count</th>
                                                                <th scope="col">ES Index</th>
                                                                <th scope="col">Signature game</th>
                                                            </tr>
                                                            </thead>
                                                            <tbody>
                                                            {generalInfo.companies.map(item => (
                                                                <tr id={item.id}>
                                                                    <th scope="row"><a href={"/publishers/"+item.id}>{item.name}</a></th>
                                                                    <td>{item.games ? item.games.length : 0}</td>
                                                                    <td>{item.games ? item.es_index : 0}</td>
                                                                    <td>{item.signature_game ? item.signature_game.name : ""}</td>
                                                                </tr>
                                                            ))}
                                                            </tbody>
                                                        </table>
                                                    </div> : <span></span>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            );
        }

        return <Container>
            <Row>
                <Col>
                    {generalInfoFormatted}
                </Col>
            </Row>
        </Container>
    }
}
